import { SxProps } from '@mui/material'
import { mapClasses } from './Map.data'

interface MapStyles {
  mapWrapper: SxProps
  infoWindow: SxProps
}

export const mapStyles: MapStyles = {
  mapWrapper: {
    position: 'relative',
    overflow: 'hidden',
    [`.${mapClasses.tooltipWrapper}`]: {
      padding: '0px !important',
      borderRadius: 4,
      boxShadow: 'unset',
    },
    [`.${mapClasses.tooltipWrapperD}`]: {
      overflow: 'unset !important',
      maxHeight: 'unset !important',
    },
    [`.${mapClasses.tooltipWrapperTc}::after`]: {
      height: 0,
    },
  },
  infoWindow: {
    px: 2.5,
    py: 1.5,
    position: 'fixed',
    width: '100%',
    zIndex: 1,
    bottom: 0,
  },
}
